// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const ShopsScreen = registerClientReference(
    function() { throw new Error("Attempted to call ShopsScreen() from the server but ShopsScreen is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/Documents/senkredi/senkredi-backoffice/app/(dashboard)/dashboard/shops/shops-screen.tsx",
    "ShopsScreen",
);
